module.exports = __webpack_public_path__ + "client/styles/fonts/SourceSansPro-SemiBold.ttf";


//////////////////
// WEBPACK FOOTER
// ./client/styles/fonts/SourceSansPro-SemiBold.ttf
// module id = 1484
// module chunks = 0